import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TipoTag } from 'src/app/models/enum';
import { TagGi } from 'src/app/models/tag-gi';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { TagGiService } from 'src/app/services/tag-gi.service';

@Component({
  selector: 'app-selecionar-tag-modal',
  templateUrl: './selecionar-tag-modal.component.html',
  styleUrls: ['./selecionar-tag-modal.component.scss']
})
export class SelecionarTagModalComponent implements OnInit {
  tags: TagGi[] = [];
  tagsSelecionadas = [];
  idCupom;
  idIntegrador;
  somenteIncluir = false;
  tagsJaInseridas = [];
  tipo: TipoTag;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<SelecionarTagModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private carregandoService: CarregandoService, private tagService: TagGiService, private notificacaoService: NotificacaoService, private pedidoService: PedidoService, private clienteService: ClienteService) {
    this.idCupom = data.idCupom;
    this.idIntegrador = data.idIntegrador;
    this.tagsSelecionadas = data.tags;
    this.tagsJaInseridas = [...this.tagsSelecionadas];
    // this.somenteIncluir = data.somenteIncluir;
    this.tipo = data.tipo;
  }

  ngOnInit() {
    this.buscarTags();
  }



  fechar() {
    this.carregandoService.mostra('salvaTags');
    let tagsSalvar;
    if (this.tagsSelecionadas && this.tagsSelecionadas !== null && this.tagsSelecionadas.length > 0) {
      tagsSalvar = this.tags.filter(p => this.tagsSelecionadas.some(t => t === p.id));
    } else {
      tagsSalvar = [];
    }

    if (this.tipo === TipoTag.pedido) {

      this.pedidoService.salvarTags(this.idCupom, tagsSalvar).subscribe(async orc => {

        this.notificacaoService.sucesso('Tags selecionadas com sucesso!!!');
        this.carregandoService.esconde('salvaTags');
        this.dialogRef.close(true);

      }, (erro) => {
        this.carregandoService.esconde('salvaTags');
        this.notificacaoService.erro(erro);
      });
    } else {
      this.clienteService.salvarTags(this.idIntegrador, tagsSalvar).subscribe(async orc => {

        this.notificacaoService.sucesso('Tags selecionadas com sucesso!!!');
        this.carregandoService.esconde('salvaTags');
        this.dialogRef.close(true);

      }, (erro) => {
        this.carregandoService.esconde('salvaTags');
        this.notificacaoService.erro(erro);
      });
    }
  }

  voltar() {
    this.dialogRef.close();
  }


  buscarTags() {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarTags(this.tipo).subscribe(
      (tags) => {
        this.tags = tags;
        this.tags.forEach(p => p.disabled = p.somenteApi);

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  removeuTag(itemRemovido: any) {
    if (this.somenteIncluir && this.tagsJaInseridas.includes(itemRemovido.value.id)) {
      this.tagsSelecionadas.splice(this.tagsJaInseridas.indexOf(itemRemovido.value.id), 0, itemRemovido.value.id);
      this.tagsSelecionadas = [...this.tagsSelecionadas];
    }
  }

}
